/**
 * 侧边栏模板
 * @author fulh
 * @update 2015年1月22日 14:16:34
 */
$.module('MM.fixedbar.tmpl', function () {
  this.fixedbar =
    '<div class="fixedbar" id="j_fixedbar"></div>\
        <div id="j_fixedbar_dialog" class="fixedbar-dialog" >\
            <div id="j_fixedbar_dialog_hd" class="fixedbar-dialog-hd">\
                <h2><span>柠檬中心</span></h2>\
            </div>\
            <div class="fixedbar-dialog-cnt">\
                <div id="j_fixedbar_loading" class="fixedbar-dialog-loading">正在拼命加载中…</div>' +
    '</div>\
    </div>';

  this.fiexedBarMenu =
    '\
    <div class="fixedbar-menu">\
        <div id="union-game" class="union-game" >\
            <h3>头号玩家</h3>\
            <%var gameList = list || data.list;\
            for (var i = 0; i < gameList.length; i++) { var item = gameList[i]; %>\
                <div data-for="<%= item.name %>" class="union-game-item">\
                    <img src="<%= item.pic%>" />\
                    <div class="union-game-name"><%= item.title %></div>\
                </div>\
            <% } %>\
        </div>\
        <ul class="fixedbar-list">\
            <li data-for="unionGame" data-login="1" class=<%= app_v === "v1" ? "union-game-tab":"" %>>\
                <i class="icon-union-game"></i>\
                <span>头号玩家</span>\
            </li>\
            <li data-for="follow" data-login="1" data-sawebclick="id=000b017&desc=button:关注">\
                    <i class="iconfont icon-guanzhuxianxing"></i>\
                    <span>关注</span>\
            </li>\
            <li\
                class="fixedbar-menu-privilege"\
                data-for="privilege"\
                data-login="1">\
                <i class="iconfont icon-tequan"></i>\
                <span>特权</span>\
            </li>\
            <li data-for="history" data-sawebclick="id=000b018&desc=button:看过">\
                <i class="iconfont icon-lishijiluxianxing"></i>\
                <span>看过</span>\
            </li>\
        </ul>\
        <ul class="fixedbar-list fixedbar-list-bottom">\
        <li class="fixedbar-menu-qq" data-for="qq" data-sawebclick="id=000b019&desc=button:客服">\
            <span>客服</span>\
        </li>\
        <li\
            data-for="tool"\
            data-login="1"\
            data-sawebclick="id=000b020&desc=button:设置"\
            <span>设置</span>\
        </li>\
        <% if(MM.user.isLogin() && MM.live){ %>\
            <li\
                class="fixedbar-menu-accuse"\
                id="j_btn_accuse"\
                style="display: <%= (MM.live && MM.live.room && MM.live.room.isLive())? "block": "none"%>;"\
                data-for="accuse">\
                <span>举报</span>\
            </li>\
        <% } %>\
        <li class="fixedbar-menu-code" data-for="code">\
            <i class="icon-weixin-guanzhu"></i>\
            <div class="weixin-gzh-text">\
                <p>公众号</p>\
                <p>二维码</p>\
            </div>\
            <div class="fixedbar-code">\
                <i class="fixedbar-code-pic fixedbar-code-weixin"></i>\
                <p class="fixedbar-code-title">关注微信<br/>了解第一手官方资讯</p>\
            </div>\
        </li>\
        <li class="fixedbar-scroll-to-top" data-for="scrollToTop" data-sawebclick="id=000b022&desc=button:返回顶部">\
            <i class="icon-scroll-to-top"></i>\
            <span>返回顶部</span>\
        </li>\
    </ul>\
    </div>\
    <div class="fixedbar-im" id="im_app"></div>';

  this.fiexedBar = this.fiexedBarMenu;

  this.fixedbarLogined = this.fiexedBarMenu;

  this.recommend =
    '<div id="j_fixedbar_recommend" class="fixedbar-dialog-item ">\
                    <div class="fixedbar-dialog-hd">\
                        <h2><span><i class="icon-base icon-fixed-follow-white"></i>主播推荐</span></h2>\
                    </div>\
                    <div class="fixedbar-dialog-bd">\
                        <ul class="fixedbar-star fix"></ul>\
                    </div>\
                </div>';

  this.recommend_list =
    '\
<%var userList = data.data || data;\
for (var i = 0; i < userList.length&&i<40; i++) { var item = userList[i]; %>\
<li>\
    <a href="/<%=item._id%>" target="_blank" class="fixedbar-star-pic"><img src="<%=item.pic_url%>" alt="<%=item.nick_name%>" />\
    <%if(item.live){%>\
    <span class="fixedbar-star-live">直播</span>\
    <%}%>\
    </a>\
    <a href="/<%=item._id%>" target="_blank" class="fixedbar-star-name">\
    <%=MM.level.createStarIcon(item.finance ? item.finance.benefit_total : 0)%>\
    <%=item.nick_name%></a>\
    <%if(item.live){%>\
    <p><i class="icon-base icon-base-eye-gray"></i><%=MM.common.createCount(item.visiter_count)%>人</p>\
    <p><i class="icon-base icon-base-time-gray"></i><%=MM.common.formatTime(item.timestamp, "hh:mm")%></p>\
    <%}%>\
</li>\
<% } %>';
  this.history =
    '<div id="j_fixedbar_history" class="fixedbar-dialog-item ">\
                    <div class="fixedbar-dialog-hd">\
                        <h2><span><i class="icon-base icon-fixed-history-white"></i>最近观看</span></h2>\
                    </div>\
                    <div class="fixedbar-dialog-bd"><ul class="follow-star fix"></ul></div>\
                </div>';
  this.history_list =
    '\
    <%if(!data.length){%><li  class="text-info">暂无观看记录</li><%}%>\
    <% for (var i = 0; i < data.length; i++) { var item = data[i]; %>\
        <li>\
            <a target="_blank" href="/<%=item.room_id%>?clickfrom=J111" >\
                <span class="follow-star-pic"><img src="<%=item.user_pic%>" alt="<%=item.nick_name%>" /></span>\
                <span class="follow-star-name"><%=item.nick_name%></span>\
            </a>\
        </li>\
    <% } %>';
  this.follow =
    '<div id="j_fixedbar_follow" class="fixedbar-dialog-item ">\
                    <div class="fixedbar-dialog-hd" style="display: none;">\
                        <h2><span><i class="icon-base icon-fixed-follow-white"></i>我的主播</span></h2>\
                    </div>\
                    <div class="fixedbar-dialog-bd">\
                        <div class="fixedbar-tab-hd fixedbar-follow-hd <%=MM.user.isBroker()?"":"fixedbar-tab-hd-3"%>">\
                            <a href="javascript:;" class="on item" data-type="follow">关注</a>\
                            <a href="javascript:;" class="item" data-type="subscribe">订阅</a>\
                            <a href="javascript:;" class="item" data-type="manage">管理</a>\
                            <%if(MM.user.isBroker()){%>\
                            <a href="" data-type="sign" class="item" >签约</a>\
                            <%}%>\
                        </div>\
                        <div class="fixedbar-follow-bd">\
                            <ul id="j_fixedbar_follow_follow" class="follow-star fix"></ul>\
                            <ul id="j_fixedbar_follow_subscribe" class="follow-subscribe fix"></ul>\
                            <ul id="j_fixedbar_follow_manage" class="follow-star fix"></ul>\
                            <ul id="j_fixedbar_follow_sign" class="follow-star fix"></ul>\
                            <ul id="j_fixedbar_follow_family" class="fixedbar-star follow-family fix"></ul>\
                        </div>\
                    </div>\
                </div>';
  this.follow_list_follow =
    '\
    <% var users = data.data.users || [], rooms = data.data.rooms || [];%>\
<%if(!rooms.length){%><li class="text-info">暂无关注的主播，点击直播间视频右上方关注主播哦！</li><%}%>\
<% for (var i = 0; i < rooms.length&&i<100; i++) { var room = rooms[i], isParty = room.showing && room.multi_room_extension_type===6; %>\
<% var user = null; for (var j = 0; j < users.length; j++) {if(users[j]._id == room.xy_star_id){user=users[j];break;}}; %>\
<%\
 if(!user){break;};\
var starIconData = MM.level.getStarIcon(user.finance ? user.finance.benefit_total : 0); %>\
    <li>\
        <a class="follow-star-item" target="_blank" href="/<%= (isParty && room.extension_room_id) || room._id%>?clickfrom=J120" data-id="<%= (isParty && room.extension_room_id) || room._id%>" >\
            <span class="follow-star-pic"> \
                <img src="<%=user.pic%>" alt="<%=user.nick_name%>" /> \
                <%if(isParty){%>\
                    <span class="party"></span>\
                <%}%>\
            </span>\
            <span class="follow-star-name"><%=user.nick_name%></span>\
            <%if(room.live){%>\
                <i class="icon-base icon-fixed-live"></i>\
            <%}%>\
        </a>\
    </li>\
<% } %>';

  this.follow_list_subscribe =
    '\
    <% var rooms = data.data.list || [];%>\
    <%if (!rooms.length){ %>\
        <li class="empty-holder">\
            <p class="empty-img"></p>\
            <span class="text-info"></span>\
        </li>\
    <%}%>\
    <% for (var i = 0; i < rooms.length&&i<40; i++) { var room = rooms[i]; var corner = room.corner_v6 || {}; %>\
        <li class="item">\
            <a target="_blank" href="/<%= room.id %>?clickfrom=J122">\
                <div class="item-cover">\
                    <img class="item-img" src="<%=room.pic_url%>" />\
                    <p class="item-badge">\
                        <img src="<%=corner.left_img%>" />\
                        <img src="<%=corner.middle_img%>" />\
                        <img src="<%=corner.right_img%>" />\
                        <span><%= corner.text %></span>\
                    </p>\
                    <% if (room.live) {%>\
                        <i class="item-live">派对中</i>\
                    <%}%>\
                </div>\
                <p class="item-name">\
                    <span class="text-overflow"><%=room.room_title%></span>\
                    <i class="item-type" style="border-color: <%=corner.border%>;color: <%= corner.border %>; "><%=["语音","视频"][room.mode||0]%></i>\
                </p>\
                <span class="item-desc"><%=room.funny_num%>人在派对中</span>\
            </a>\
        </li>\
<% } %>';

  this.follow_list_manage =
    '\
<% var users = data.data.users || [], rooms = data.data.rooms || [];%>\
<%if(!rooms.length){%><li class="text-info">暂无</li><%}%>\
<% for (var i = 0; i < rooms.length&&i<40; i++) { var room = rooms[i]; %>\
<% var user = null; for (var j = 0; j < users.length; j++) {if(users[j]._id == room.xy_star_id){user=users[j];break;}}; %>\
<% var starIconData = MM.level.getStarIcon(user.finance ? user.finance.benefit_total : 0); %>\
<li>\
<a target="_blank" href="/<%= room._id %>?clickfrom=J122">\
        <span class="follow-star-pic"><img src="<%=user.pic%>" alt="<%=user.nick_name%>" /></span>\
        <span class="follow-star-name"><%=user.nick_name%></span>\
        <%if(room.live){%>\
            <i class="icon-base icon-fixed-live"></i>\
        <%}%>\
    </a>\
</li>\
<% } %>';

  this.fixedbar_help =
    '<div class="fixedbar-help-hd"><h3>常用帮助</h3></div>\
    <ul>\
        <li><a href="/notice/4" target="_blank" >1. 什么是柠檬？</a></li>\
        <li><a href="/notice/16" target="_blank" >2. 什么是财富称号？</a></li>\
        <li><a href="/notice/10120" target="_blank" >3. 明星等级说明？</a></li>\
        <li><a href="/notice/256" target="_blank" >4. 什么是闪耀财星？</a></li>\
        <li><a href="/notice/30" target="_blank" >5. 富豪称号与私聊规则？</a></li>\
        <li><a href="/medal.html" target="_blank" >6. 么么直播徽章大全？</a></li>\
    </ul>\
    <div class="fixedbar-qq-action"><a href="/help/7" target="_blank" class="btn btn-primary btn-lg">帮助中心</a></div>\
    ';

  this.qq =
    '<div  id="j_fixedbar_qq" class="fixedbar-dialog-item">\
    <div class="fixedbar-dialog-hd">\
    <h2><span><i class="icon-base icon-fixed-qq-white"></i>在线帮助</span></h2>\
    </div>\
    <div class="fixedbar-dialog-bd">\
        <div class="fixedbar-help-hd" style="display: none ;"><h3>在线帮助</h3></div>\
        <div class="fixedbar-qq">\
            <div class="fixedbar-qq-action">\
            <a href="javascript:;"  onclick="MM.user.kefu.showKefu()"  class="btn btn-primary btn-lg">联系客服</a>\
            <a href="javascript:;" onclick="MM.user.kefu.showKefu()" class="btn btn-primary\
             btn-lg">版权投诉</a>\
            </div>\
        </div>\
        <div  id="j_fixedbar_help" class="fixedbar-help">' +
    this.fixedbar_help +
    '</div>\
    </div>\
</div>';

  this.tool =
    '<div id="j_fixedbar_tool" class="fixedbar-dialog-item ">\
                    <div class="fixedbar-dialog-hd" style="display: none;"></div>\
                    \
                    <div class="fixedbar-dialog-bd">\
                        <div class="fixedbar-tab-hd fixedbar-tool-hd">\
                            <a href="javascript:;" class="on item" data-type="user">个性设置</a>\
                        </div>\
                        \
                        <div class="fixedbar-tool-bd">\
                            <div id="j_fixedbar_tool_user">\
                                <dl class="fixedbar-tool">\
                                    <%for(var key in switch_list){%>\
                                    <%if(switch_list[key].type=="user"){%>\
                                    <dt><h4><%=switch_list[key].title%></h4><div data-type="<%=key%>" class="tool-switch <%=switch_list[key].status?"":"tool-switch-off"%>"><p><span>已开</span><i></i><span>已关</span></p></div></dt>\
                                    <dd><%=switch_list[key].desc%></dd>\
                                    <%}%>\
                                    <%}%>\
                                </dl>\
                            </div>\
                        </div>\
                    </div>\
                </div>';

  this.tool_tab_star =
    '\
        <a href="javascript:;" class="on item" data-type="star">主播设置</a>\
        <a href="javascript:;" class="item" data-type="user">个性设置</a>\
    ';

  this.tool_tab_family =
    '\
        <a href="javascript:;" class="on" data-type="family">家族房设置</a>\
        <a href="javascript:;" data-type="user">个性设置</a>\
    ';

  //MM.live.room.isLimitPerson()
  //MM.live.room.isRankVisible()
  this.tool_tab_star_bd =
    '\
        <div id="j_fixedbar_tool_star">\
            <dl class="fixedbar-tool">\
            <%for(var key in switch_list){var item=switch_list[key];%>\
            <%if(switch_list[key].type=="star"){%>\
            <dt>\
                <h4><%=item.title%></h4>\
                <div data-type="<%=key%>" class="tool-switch <%=item.status?"":"tool-switch-off"%>"><p><span>已开</span><i></i><span>已关</span></p></div>\
            </dt>\
            <dd><%=item.desc%></dd>\
            <%}%>\
            <%}%>\
            </dl>\
            <ul  class="ucenter-star">\
                    <% if (data.isOperate) { %>\
                        <li><a href="javascript:;" data-type="cover">设置封面</a></li>\
                    <% } %> \
                    <li><a href="javascript:;" data-type="nickFormat">设置马甲</a></li>\
                    <li><a href="javascript:;" data-type="notify">设置开播提醒<i class="new"></i></a></li>\
                    <li><a href="javascript:;" data-type="greeting">设置问候语</a></li>\
                    <li><a href="javascript:;" data-type="roomBg">设置背景图</a></li>\
            </ul>\
        </div>\
        ';
  //移动火拼
  //<% if (data.isRoomOwner && !data.isV2Live) { %>\
  // <li><a href="javascript:;" data-type="pk">发起火拼</a></li>\
  // <li><a href="javascript:;" data-type="pk-log">火拼记录</a></li>\
  //         <% } %>\
  //MM.room.family && MM.user.isRoomLeader(MM.live.room.getRoomId())
  this.tool_tab_family_bd =
    '\
        <div id="j_fixedbar_tool_family" >\
            <ul class="ucenter-leader">\
            <li><a href="javascript:;" data-type="cover">设置封面</a></li>\
            <li><a href="javascript:;" data-type="name">设置名称</a></li>\
            <li><a href="javascript:;" data-type="greeting">设置公告</a></li>\
            <li><a href="javascript:;" data-type="addStar">主播管理</a></li>\
            <li><a href="javascript:;" data-type="roomBg">设置背景图</a></li>\
            </ul>\
        </div>\
    ';

  this.broadcast =
    '\
    <div><span class="broadcast-speaker">喇叭剩余：<i></i>(优先使用)</span></div>\
    <div class="broadcast-bd fix">\
        <textarea placeholder="每条广播2000柠檬，每个房间都可以收到哦。使用喇叭时5分钟内最多可发送1条广播！" maxlength="50"></textarea>\
    </div>\
    <div class="broadcast-ft fix">\
        <a class="expression-btn" href="javascript:void(0);" title="表情"></a>\
        <a class="btn btn-disable btn-broadcast" href="javascript:void(0);">发布</a>\
        <span class="broadcast-num">还能输入50个字</span>\
    </div>';
});
